import { Entity } from "@generated/client/graphql";
import { atom } from "jotai";

export const toUpdateSiteAtom = atom<Entity | undefined>(undefined);
